/**
 * 무료 배지 아이콘 (Figma 원본, 24×24 fill).
 *
 * ⚠️ 손으로 근사하지 말 것 — Figma node 에서 추출한 path 다. 이전에 `TrustBadges` 가
 * 라인 아이콘을 손으로 그려 넣어 디자인과 계열이 갈렸다(#5095 리뷰).
 *
 * 색은 `currentColor` — 원본은 `#4D5358`(coolgray-70) 하드코딩이지만, 호출처에서
 * `hover:text-*` 로 색이 바뀌어야 하므로 상속으로 바꿨다.
 */
export default function FreeBadgeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM6.5 9.25V10.6113H9.77637L10.3154 11.1455V16.25H11.666V10.5752L10.3311 9.25H6.5ZM12.333 10.5752V16.25H13.6836V11.1455H13.6846L14.2217 10.6113H17.5V9.25H13.6689L12.333 10.5752Z"
        fill="currentColor"
      />
    </svg>
  );
}
